import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'
import { themeGet } from '@styled-system/theme-get'
import { border, color, compose, margin, space, textStyle } from 'styled-system'
import {
  SharePoint,
  GoogleDrive,
  Confluence,
} from 'src/components/Icons/Dependencies'
import { StyledDropdownMenu } from 'src/components/Reusable/StandardDropdown/StandardDropdown.styles'
import {
  StyledInputError,
  StyledLabel,
} from '../../../../Reusable/Inputs/TextInput/styles'

export const EvidenceDetailsContainer = styled.div`
  position: relative;
`

export const StyledLink = styled.a.attrs({
  mb: 'xxxs',
  textStyle: 'body.default',
})`
  ${compose(margin, textStyle)}
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
`

export const Label = styled.label.attrs({
  mb: 'xxxs',
  textStyle: 'body.default',
})`
  ${compose(margin, textStyle)}
  display: flex;
  justify-content: space-between;
`

export const FileInfoContainer = styled.div.attrs({
  p: 's',
  border: '1px solid',
  borderColor: 'border.neutral.light',
  bg: 'white',
  color: 'text.default',
  textStyle: 'form.disabled',
})<{ $isDisabled?: boolean }>`
  ${compose(space, border, color, textStyle)}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 240px;

  ${({ $isDisabled }) =>
    $isDisabled
      ? `
    pointer-events: none;
    cursor: default;
  `
      : `
    :hover {
      background-color: ${themeGet('colors.bg.neutralHover')};
      border-color: ${themeGet('colors.border.neutral.base')};
      cursor: pointer;
    }

    :active,
    :focus {
      background-color: white;
      border-color: ${themeGet('colors.border.neutral.dark')};
      outline: none;
    }
  `}

  .filename {
    ${themeGet('textStyles.subtitle.1')};
    margin-bottom: ${themeGet('space.xxs')}px;
  }

  .last-modified {
    ${themeGet('textStyles.subtitle.caption')}
  }
`

export const FilesInfoContainer = styled.div.attrs({
  p: 's',
  border: '1px solid',
  borderColor: 'border.neutral.light',
  bg: 'white',
  color: 'text.default',
  textStyle: 'form.disabled',
})`
  ${compose(space, border, color, textStyle)}
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  position: relative;
  height: 240px;
  padding: 24px;
  overflow-y: auto;

  :active,
  :focus {
    background-color: white;
    border-color: ${themeGet('colors.border.neutral.dark')};
    outline: none;
  }
`

export const FilesInfoContainerRow = styled.div.attrs({
  p: 's',
  borderColor: 'border.neutral.light',
  bg: 'white',
  color: 'text.default',
  textStyle: 'form.disabled',
})`
  ${compose(space, color, textStyle)}
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  padding: 0;

  :active,
  :focus {
    background-color: white;
    border-color: ${themeGet('colors.border.neutral.dark')};
    outline: none;
  }

  .filename {
    ${themeGet('textStyles.subtitle.1')};
    margin-bottom: 0;
    margin-top: 2px;
  }

  .last-modified {
    ${themeGet('textStyles.subtitle.caption')}
    margin-top: 2px;
  }
`

export const FilesLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 240px;
`

export const AddEvidenceError = styled(StyledInputError)`
  display: block;
`

export const CaptionLabel = styled(StyledLabel)`
  margin: 0;
`

export const AddEvidenceFormBody = styled.form`
  display: flex;
  flex-direction: column;
`

export const UploadInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const UploadInfo = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${themeGet('colors.text.low')};
  font-size: ${themeGet('textStyles.caption')};
`
export const ConfluenceIcon = styled(Confluence)`
  width: 48px;
  height: 48px;
`
export const ConfluenceSmallIcon = styled(Confluence)`
  width: 24px;
  height: 24px;
`

export const SharePointIcon = styled(SharePoint)`
  width: 48px;
  height: 48px;
`
export const SharePointSmallIcon = styled(SharePoint)`
  width: 24px;
  height: 24px;
`
export const GoogleDriveIcon = styled(GoogleDrive)`
  width: 48px;
  height: 48px;
`
export const GoogleDriveSmallIcon = styled(GoogleDrive)`
  width: 24px;
  height: 24px;
`
export const LinkerCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 24px;
  overflow: visible;
  height: 100%;
  border: 1px solid ${palette.neutral[100]};
  transition: all 0.2s ease-in-out;

  :hover {
    background-color: ${palette.neutral[40]};
    border-color: ${palette.neutral[200]};
    cursor: pointer;
  }
`
export const SelectionCardWrapper = styled.div`
  flex: 1;
  height: 100%;
  margin-right: ${themeGet('space.l')}px;
`
export const OutlinedDropdownMenu = styled(StyledDropdownMenu)`
  border: 1px solid ${palette.neutral[100]};
  border-radius: 16px;
  padding: 4px 8px;
  background-color: #fff;
`
